
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic/[id]",
      function () {
        return require("private-next-pages/topic/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topic/[id]"])
      });
    }
  